import { Expose, Type } from "class-transformer";
import { Afiliate } from "src/shared/models/affiliate.model";
import { PgaPolicy } from "src/shared/models/pga-policy.model";

export class EpsPlan extends PgaPolicy {
    @Expose() affiliateCode = 1;
    @Expose() insuredCode = -1;
    @Expose() contractorId = -1;
    @Expose() status = ""; // VIGENTE
    @Expose() insuredAmount = 0.0;
    @Expose()
    @Type(() => Afiliate)
    affiliates?: Afiliate[];

    get longId() {
        return `NS-${this.insuredCode}`;
    }
}
